import React from 'react';

import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

type Props = {
  tag: string;
  onSearch: (search: string) => void;
};

const PipeTag = ({ tag, onSearch }: Props) => {
  return (
    <Button
      onClick={evt => {
        evt.stopPropagation();
        onSearch(tag);
      }}
      spacing="none"
    >
      <div
        style={{
          padding: `0 ${token('space.025', '2px')} 1px`,
          font: token('font.body.small'),
        }}
      >
        {tag}
      </div>
    </Button>
  );
};

export default React.memo(PipeTag);
